module.exports = __webpack_public_path__ + "static/4.Extended Hours Trading Risk Disclosure Statement-b6cff707438907ea3f1b868c87f37fbb.pdf";